import React, { useState } from "react";
import {
    Box,
    Button,
    Dialog,
    DialogActions,
    DialogContent,
    DialogTitle,
    TextField,
    Typography,
} from "@mui/material";
import emailjs from "emailjs-com";
import { styled } from "@mui/material/styles";

const StyledDialog = styled(Dialog)(({ theme, bgColor, textColor }) => ({
    "& .MuiPaper-root": {
        backgroundColor: bgColor || "#000000", // Default to black if no color is provided
        borderRadius: "16px",
        boxShadow: "0px 0px 20px 6px rgba(95, 114, 255, 0.3)", // Glow effect
        padding: theme.spacing(3),
        maxWidth: "500px",
        margin: "auto",
        color: textColor || "#ffffff", // Default to white if no text color is provided
        animation: "fadeIn 0.5s",
    },
}));

function EmailModal({ bgColor, textColor, inputBgColor, inputTextColor }) {
    const [open, setOpen] = useState(false);
    const [emailDetails, setEmailDetails] = useState({
        from_name: "",
        from_email: "",
        subject: "",
        message: "",
    });

    const handleOpen = () => setOpen(true);
    const handleClose = () => setOpen(false);

    const handleInputChange = (e) => {
        const { name, value } = e.target;
        setEmailDetails({
            ...emailDetails,
            [name]: value,
        });
    };

    const handleSubmit = (e) => {
        e.preventDefault();

        emailjs
            .send(
                "service_5mqe9pk",
                "template_0vonrlh",
                emailDetails,
                "EDRwOOE3HuGQqbwGr"
            )
            .then(
                (result) => {
                    console.log(result.text);
                    handleClose();
                    alert("Your message has been sent!");
                },
                (error) => {
                    console.log(error.text);
                    alert("Failed to send the message. Please try again.");
                }
            );
    };

    return (
        <div>
            <Button
                variant="contained"
                color="primary"
                size="small"
                sx={{
                    minWidth: "auto",
                    whiteSpace: "nowrap",
                    padding: "4px 12px",
                    fontSize: "0.875rem",
                }}
                onClick={handleOpen}
            >
                Contact for inquiries
            </Button>

            <StyledDialog open={open} onClose={handleClose} bgColor={bgColor} textColor={textColor}>
                <DialogTitle
                    sx={{
                        fontSize: "2rem",
                        fontWeight: "bold",
                        color: textColor || "#ffffff", // Use textColor prop or default to white
                        textAlign: "center",
                    }}
                >
                    Contact Us
                </DialogTitle>
                <DialogContent>
                    <Typography
                        variant="body1"
                        
                        gutterBottom
                        sx={{
                            color: textColor ? "#cccccc" : "#ffffff", // Adjust text color based on the prop
                            marginBottom: "16px",
                            fontFamily: 'sans-serif', // Minimalistic font
                        }}
                    >
                        Please fill out the form below, and we will get back to you as soon as possible.
                    </Typography>
                    <form id="emailForm" onSubmit={handleSubmit}>
                        <TextField
                            label="Your Name"
                            name="from_name"
                            value={emailDetails.from_name}
                            onChange={handleInputChange}
                            fullWidth
                            margin="normal"
                            required
                            InputLabelProps={{ style: { color: inputTextColor || "#cccccc" } }}
                            sx={{
                                backgroundColor: inputBgColor || "#1e1e1e", // Use inputBgColor prop or default color
                                color: inputTextColor || "#ffffff",
                                borderRadius: "8px",
                                input: { color: inputTextColor || "#ffffff" },
                                boxShadow: "0px 2px 4px rgba(0, 0, 0, 0.3)",
                                "& .MuiInputBase-root": {
                                    padding: "10px 12px", // Adjust padding
                                },
                                fontFamily: 'sans-serif', // Minimalistic font
                            }}
                        />
                        <TextField
                            label="Your Email"
                            name="from_email"
                            type="email"
                            value={emailDetails.from_email}
                            onChange={handleInputChange}
                            fullWidth
                            margin="normal"
                            required
                            InputLabelProps={{ style: { color: inputTextColor || "#cccccc" } }}
                            sx={{
                                backgroundColor: inputBgColor || "#1e1e1e",
                                color: inputTextColor || "#ffffff",
                                borderRadius: "8px",
                                input: { color: inputTextColor || "#ffffff" },
                                boxShadow: "0px 2px 4px rgba(0, 0, 0, 0.3)",
                                "& .MuiInputBase-root": {
                                    padding: "10px 12px", // Adjust padding
                                },
                                fontFamily: 'sans-serif', // Minimalistic font

                            }}
                        />
                        <TextField
                            label="Subject"
                            name="subject"
                            value={emailDetails.subject}
                            onChange={handleInputChange}
                            fullWidth
                            margin="normal"
                            required
                            InputLabelProps={{ style: { color: inputTextColor || "#cccccc" } }}
                            sx={{
                                backgroundColor: inputBgColor || "#1e1e1e",
                                color: inputTextColor || "#ffffff",
                                borderRadius: "8px",
                                input: { color: inputTextColor || "#ffffff" },
                                boxShadow: "0px 2px 4px rgba(0, 0, 0, 0.3)",
                                "& .MuiInputBase-root": {
                                    padding: "10px 12px", // Adjust padding
                                },
                                fontFamily: 'sans-serif', // Minimalistic font

                            }}
                        />
                        <TextField
                            label="Message"
                            name="message"
                            multiline
                            rows={4}
                            value={emailDetails.message}
                            onChange={handleInputChange}
                            fullWidth
                            margin="normal"
                            required
                            InputLabelProps={{ style: { color: inputTextColor || "#cccccc" } }}
                            sx={{
                                backgroundColor: inputBgColor || "#1e1e1e",
                                color: inputTextColor || "#ffffff",
                                borderRadius: "8px",
                                input: { color: inputTextColor || "#ffffff" },
                                boxShadow: "0px 2px 4px rgba(0, 0, 0, 0.3)",
                                "& .MuiInputBase-root": {
                                    padding: "10px 12px", // Adjust padding for message field
                                    minHeight: "100px", // Ensure there's enough space for multiline
                                },
                                fontFamily: 'sans-serif', // Minimalistic font

                            }}
                        />
                        <DialogActions
                            sx={{
                                display: "flex",
                                justifyContent: "center",
                                marginTop: "16px",
                            }}
                        >
                            <Button
                                onClick={handleClose}
                                sx={{
                                    color: inputTextColor || "#bbbbbb",
                                    fontFamily: "'Helvetica Neue', sans-serif",
                                    "&:hover": { color: inputTextColor || "#ffffff" },
                                }}
                            >
                                Cancel
                            </Button>
                            <Button
                                type="submit"
                                variant="contained"
                                sx={{
                                    backgroundColor: "#6200ea",
                                    color: "#ffffff",
                                    fontFamily: "'Helvetica Neue', sans-serif",
                                    padding: "8px 16px",
                                    borderRadius: "8px",
                                    "&:hover": { backgroundColor: "#3700b3" },
                                    fontFamily: 'sans-serif', // Minimalistic font

                                }}
                            >
                                Send Message
                            </Button>
                        </DialogActions>
                    </form>
                </DialogContent>
            </StyledDialog>
        </div>
    );
}

export default EmailModal;
